<div dapLibFocusTrap *dapLibHideForBreakpoint="'for-Small-Down'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<div *dapLibShowForBreakpoint="'for-Small-Down'">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ng-template #content>
  <dap-lib-overlay-backdrop (click)="closed.emit()"></dap-lib-overlay-backdrop>
  <dap-lib-scroll-lock></dap-lib-scroll-lock>

  <div class="overlay">
    <ng-content></ng-content>
  </div>
</ng-template>
